import appAnalytics from '@/utils/tracking'

const segmentEventsNamesVideo = {
  0: appAnalytics.events.SP_CLICK_HC_VIDEO,
  1: appAnalytics.events.SP_CLICK_RI_VIDEO,
  2: appAnalytics.events.SP_CLICK_VP_VIDEO,
  3: appAnalytics.events.SP_CLICK_HO_VIDEO,
}
const segmentEventsNamesTile = {
  0: appAnalytics.events.SP_CLICK_HC_TILE,
  1: appAnalytics.events.SP_CLICK_RI_TILE,
  2: appAnalytics.events.SP_CLICK_VP_TILE,
  3: appAnalytics.events.SP_CLICK_HO_TILE,
}

export { segmentEventsNamesVideo, segmentEventsNamesTile }

/** Valid product indices for Studio Plus events */
export type ProductIndex = 0 | 1 | 2 | 3

/** Video event names */
export type VideoEventName = typeof segmentEventsNamesVideo[ProductIndex]

/** Tile event names */
export type TileEventName = typeof segmentEventsNamesTile[ProductIndex]